// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatMain {
    max-width: 600px;
    margin: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.chatHeader {
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    /* padding: 40px 18px 5px 18px; */
    padding: 40px 0 5px 0;
    margin: 0 18px;
    border-bottom: 1px #BB8D6C solid;
    z-index: 10;
}

.chatUserAvatar {
    width: 60px;
    aspect-ratio: 1;
    border-radius: 8px;
    object-fit: cover;
    margin: 0 8px 0 27px;
}

.chatUserInfo {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.chatUserInfo h2 {
    margin: 0;
    color: #4B2D10;
    font-weight: 700;
    font-size: 20px;
}

.chatUserInfo p {
    color: #8E3B00;
    font-size: 16px;
}

.chatUserStatus {
    margin: 0;
    font-size: 14px;
    color: #666;
}

.chatMessagesContainer {
    flex-grow: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.message {
    position: relative;
    max-width: 70%;
    background-color: #FFF4D9;
    padding: 7px 22px;
    border-radius: 16px;
    color: #8E3B00;
    font-size: 16px;
    word-wrap: break-word;
}

.tail {
    position: absolute;
    bottom: -12px;
}

.message.received .tail {
    left: 0;
}

.message.sent .tail {
    right: 0;
    transform: scaleX(-1);
}

.message.received .arrowsRead {
    display: none;
}

.message.sent .arrowsRead {
    position: absolute;
    bottom: 3px;
    right: calc(100% + 8px);
}

.message.received {
    align-self: flex-start;
    /* padding: 7px 25px 21px 16px; */
}

.message.sent {
    align-self: flex-end;
}

.message .time {
    position: absolute;
    bottom: 0;
    color: #BB8D6C;
    font-weight: 500;
    font-size: 12px;
}

.message.received .time {
    left: calc(100% + 5px);
}

.message.sent .time {
    right: calc(100% + 30px);
}

.chatInputBlock {
    display: flex;
    gap: 10px;
    padding: 22px 38px;
    background-color: #FFE4D0;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    position: sticky;
    bottom: 0;
}

.chatInput {
    height: 36px;
    flex-grow: 1;
    border: 1px solid #ccc;
    color: #8E3B00;
    font-size: 24px;
    outline: none;
    border: none;
    background: none;
}

.chatInput::placeholder {
    color: #8E3B00;
    font-size: 24px;
}

.chatInput:focus {
    border-color: #007bff;
}

.chatSendButton {
    width: 35px;
    height: 35px;
    outline: none;
    border: none;
    background: none;
    cursor: pointer;
}

.sendIcon {
    fill: #4B2D10;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/Chat.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;IACd,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".chatMain {\n    max-width: 600px;\n    margin: auto;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.chatHeader {\n    position: sticky;\n    top: 0;\n    display: flex;\n    align-items: center;\n    /* padding: 40px 18px 5px 18px; */\n    padding: 40px 0 5px 0;\n    margin: 0 18px;\n    border-bottom: 1px #BB8D6C solid;\n    z-index: 10;\n}\n\n.chatUserAvatar {\n    width: 60px;\n    aspect-ratio: 1;\n    border-radius: 8px;\n    object-fit: cover;\n    margin: 0 8px 0 27px;\n}\n\n.chatUserInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.chatUserInfo h2 {\n    margin: 0;\n    color: #4B2D10;\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.chatUserInfo p {\n    color: #8E3B00;\n    font-size: 16px;\n}\n\n.chatUserStatus {\n    margin: 0;\n    font-size: 14px;\n    color: #666;\n}\n\n.chatMessagesContainer {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.message {\n    position: relative;\n    max-width: 70%;\n    background-color: #FFF4D9;\n    padding: 7px 22px;\n    border-radius: 16px;\n    color: #8E3B00;\n    font-size: 16px;\n    word-wrap: break-word;\n}\n\n.tail {\n    position: absolute;\n    bottom: -12px;\n}\n\n.message.received .tail {\n    left: 0;\n}\n\n.message.sent .tail {\n    right: 0;\n    transform: scaleX(-1);\n}\n\n.message.received .arrowsRead {\n    display: none;\n}\n\n.message.sent .arrowsRead {\n    position: absolute;\n    bottom: 3px;\n    right: calc(100% + 8px);\n}\n\n.message.received {\n    align-self: flex-start;\n    /* padding: 7px 25px 21px 16px; */\n}\n\n.message.sent {\n    align-self: flex-end;\n}\n\n.message .time {\n    position: absolute;\n    bottom: 0;\n    color: #BB8D6C;\n    font-weight: 500;\n    font-size: 12px;\n}\n\n.message.received .time {\n    left: calc(100% + 5px);\n}\n\n.message.sent .time {\n    right: calc(100% + 30px);\n}\n\n.chatInputBlock {\n    display: flex;\n    gap: 10px;\n    padding: 22px 38px;\n    background-color: #FFE4D0;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    position: sticky;\n    bottom: 0;\n}\n\n.chatInput {\n    height: 36px;\n    flex-grow: 1;\n    border: 1px solid #ccc;\n    color: #8E3B00;\n    font-size: 24px;\n    outline: none;\n    border: none;\n    background: none;\n}\n\n.chatInput::placeholder {\n    color: #8E3B00;\n    font-size: 24px;\n}\n\n.chatInput:focus {\n    border-color: #007bff;\n}\n\n.chatSendButton {\n    width: 35px;\n    height: 35px;\n    outline: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n}\n\n.sendIcon {\n    fill: #4B2D10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
